import type { VatRateCountVm, VatSourceVm } from '@krp/platform-ui'
import type { AqsiTaxSummary } from '@krp/resource-aqsi-ui'

import type { QueryLike } from '../platform/vatSettingsModel'

/** Сборка vm ставки НДС кабинета AQSI. Без React, без store. */

export function aqsiSourceVm(args: { id: string; title: string; summary: AqsiTaxSummary | null; query: QueryLike }): VatSourceVm {
  const { id, title, summary, query } = args
  const base = { id, title, badge: 'AQSI', rates: [] as VatRateCountVm[], total: null, withVat: null, withoutVat: null, editor: null }
  if (summary === null) {
    return query.isError
      ? { ...base, status: 'error', message: query.errorMessage, note: null }
      : { ...base, status: 'loading', message: null, note: null }
  }
  if (!summary.available) return { ...base, status: 'no-data', message: summary.reason, note: null }
  return {
    ...base,
    status: 'ready',
    message: null,
    total: summary.total,
    withVat: summary.withTax,
    withoutVat: summary.withoutTax,
    rates: summary.byTax.map((item) => ({ key: `tax-${item.tax}`, label: `Код ставки кабинета ${item.tax}`, count: item.count })),
    note: 'Кабинет отдаёт ставку кодом, без названия. Ставку в кабинете отсюда не меняем: НДС контролируется в 1С.',
  }
}
